import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { Subject } from "rxjs";

@Component({
  selector: "ll-confirm-redeem",
  templateUrl: "./confirm-redeem.component.html",
  styleUrls: ["./confirm-redeem.component.scss"]
})
export class ConfirmRedeemComponent implements OnInit {
  action = new Subject();
  description: string;

  constructor(public modalRef: MDBModalRef) {}

  ngOnInit(): void {}

  yes() {
    this.action.next(true);
    this.modalRef.hide();
  }
  no() {
    this.action.next(false);
    this.modalRef.hide();
  }
}
